import { getColorIndex } from '../../../theming/utilities/getColorIndex'
import type { Tokens } from '../../../theming/types'
import type { AvatarProps } from '..'

export default (config: {
  props: Pick<AvatarProps, 'colorIndex' | 'shape'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  const indexedColor = getColorIndex(props.colorIndex)

  return {
    default: {
      avatar: {
        color: indexedColor ? indexedColor.color : tokens.avatarBgColor1,
        backgroundColor: indexedColor
          ? indexedColor.backgroundColor
          : tokens.avatarBgColor1,
      },
    },
    placeholder: {
      avatar: {
        backgroundColor:
          props.colorIndex === -1
            ? tokens.avatarBgColorSign
            : tokens.avatarBgColorPlaceholder,
        color: tokens.iconColorEmphasis,

        '& > svg': {
          borderRadius: 0,
          fill: tokens.iconColorEmphasis,
          height: '50%',
          width: '50%',
        },
      },
    },

    sizeXxlarge: {
      avatar: {
        ...tokens.fontHeadingXS,
        borderRadius:
          props.shape === 'square' ? tokens.radiusSizeS : tokens.radiusSizeFull,
        height: '48px',
        width: '48px',
      },
    },

    sizeXlarge: {
      avatar: {
        ...tokens.fontHeadingXS,
        borderRadius:
          props.shape === 'square' ? tokens.radiusSizeS : tokens.radiusSizeFull,
        height: '48px',
        width: '48px',
      },
    },

    sizeLarge: {
      avatar: {
        ...tokens.fontHeadingXS,
        borderRadius:
          props.shape === 'square' ? tokens.radiusSizeS : tokens.radiusSizeFull,
        height: '48px',
        width: '48px',
      },
    },

    sizeMedium: {
      avatar: {
        ...tokens.fontHeadingXXS,
        borderRadius:
          props.shape === 'square' ? tokens.radiusSizeS : tokens.radiusSizeFull,
        height: '40px',
        width: '40px',
      },
    },

    sizeSmall: {
      avatar: {
        ...tokens.fontDetailS,
        borderRadius:
          props.shape === 'square'
            ? tokens.radiusSizeXS
            : tokens.radiusSizeFull,
        height: '32px',
        width: '32px',
      },
    },

    sizeXsmall: {
      avatar: {
        ...tokens.fontDetailXS,
        borderRadius:
          props.shape === 'square'
            ? tokens.radiusSizeXS
            : tokens.radiusSizeFull,
        height: '24px',
        width: '24px',
      },
    },
  } as const
}
